export const PAGE_PATH = '/blocked';
